export default async function PostRequestPolicyDetails(
    payload) {
    // const url = 'http://adviser-local.delivery.lan' + "/api/TAL/AccountRecord/SubmitRequestPolicyDocuments"; // note: local testing
    const url = "/api/TAL/AccountRecord/SubmitRequestPolicyDocuments";

    try {
        const response = await fetch(url, {
            "method": "POST",
            headers: new Headers({
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(payload)
        });

        if (!response) {
            throw Error("No response");
        } 
        else if (!response.ok) {
            throw Error(response.statusText);
        }

        return response;
    } catch (error) {
        console.log(error);
    }
}